// src/components/TopHeader.tsx
import React from "react";
import logo from "./logo-with-brain.png"; // adjust if logo is elsewhere

const Footer = () => {
    return (
        <div className="d-flex justify-content-between align-items-center px-4 py-2 border-bottom bg-white" style={{ height: '5vh' }}>
            <div className="d-flex align-items-center gap-2">
                {/* <img src={logo} alt="Logo" style={{ height: "vh" }} /> */}
                {/* <span className="fs-5 fw-bold text-primary">Constelacion</span> */}
            </div>
            <span className="text-muted small">Powered by 
            <a href="https://afinidata.com" target="_blank" rel="noopener noreferrer">
            <img src={logo} alt="Logo" style={{ height: "5vh", paddingBottom:10, paddingLeft:10, cursor: 'pointer' }} />
            </a>
            </span>
        </div>
    );
};

export default Footer;